import { createContext, useCallback, useContext, useRef, useState } from "react";
import { AdminModal } from "./AdminModal";
import { AdminButton } from "../AdminButton/AdminButton";

const ConfirmContext = createContext(null);

// Promise-based replacement for react-confirm-alert's confirmAlert() -
// every delete/cancel confirmation in the app used that library's
// default, unthemed CSS. Usage: const ok = await confirm({title, message});
export const ConfirmProvider = ({ children }) => {
  const [state, setState] = useState(null);
  const resolver = useRef(null);

  const confirm = useCallback(({ title, message, confirmLabel = "Yes", cancelLabel = "No", danger = false }) => {
    setState({ title, message, confirmLabel, cancelLabel, danger });
    return new Promise((resolve) => {
      resolver.current = resolve;
    });
  }, []);

  const close = (result) => {
    setState(null);
    resolver.current?.(result);
    resolver.current = null;
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <AdminModal
        isOpen={Boolean(state)}
        onClose={() => close(false)}
        title={state?.title}
        size="sm"
        footer={
          <>
            <AdminButton variant="secondary" onClick={() => close(false)}>
              {state?.cancelLabel}
            </AdminButton>
            <AdminButton variant={state?.danger ? "danger" : "primary"} onClick={() => close(true)}>
              {state?.confirmLabel}
            </AdminButton>
          </>
        }
      >
        {state?.message}
      </AdminModal>
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => useContext(ConfirmContext);
